import Encrypter from "json-file-encrypt";

// This assumes the encryption key is set in your environment
const encryptionKey = new Encrypter.encryptor(process.env.REACT_APP_ENCRYPT_KEY);

const EncryptionUtil = {
  encrypt(data) {
    const text = JSON.stringify(data);
    return encryptionKey.encrypt(text);
  },

  decrypt(encrypted) {
    const decryptedText = encryptionKey.decrypt(encrypted);
    return JSON.parse(decryptedText);
  },
  
  obfuscate(data) {
    return btoa(encodeURIComponent(JSON.stringify(data)));
  },

  deobfuscate(encoded) {
    return JSON.parse(decodeURIComponent(atob(encoded)));
  }
};

export default EncryptionUtil;
